import { useEffect, useState } from 'react';
import { useFont } from '../../../ContextFont';
import Advogado from'../../../acets/adv.jpg'
import IcoEdit from'../../../acets/icon/edit.svg'
import Efct13 from '../../../acets/efectsfilters/13.png'

export default function Lay22(props){
  const { fonte, alterarFonte, imagens, adicionarImagem, handleDownloadImage } = useFont();
  const [titulo, setTitulo]=useState(props.datal.titulo)
  const [subtitulo,setSubtitulo]=useState(props.datal.subtitulo)
  const [modalData, setModaldata]=useState(false)
  const [numimg,setNumimg]=useState(1)
  useEffect(() => {
    // Atualiza os estados locais quando props.datal é alterado
    setTitulo(props.datal.titulo);
    setSubtitulo(props.datal.subtitulo);
  }, [props.datal]); 
  return(
    <div className='w33 cell-tamanho90 center celular b2 cont-circ7 bordaElements ma10b0'>
    <div className='p10 b2 w10 cont-circ50pc fb'>22</div>
    <div id="resultImg22" className="w100 h40 column between cell-tamanho "style={{ backgroundImage: `url(${imagens.length > 0 ? imagens[numimg].urls.small : Advogado})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
      
      <div className=" w100 h40 row center ">
      <div className=' h40  w100 cell-tamanho' >
        <div className='w100 h40  ' style={{ backgroundImage: `url('${Efct13}')`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat',backgroundPosition:'center'}}>
        <div className=" w100 h40 row end cell-tamanho">
          <div className="w50 h40">

          </div>
          <div className="w40 h40 row end" >
            <div className="column center h31" >
              <div  className="p7 column" > 
                <label className='c3 fb ' style={{fontSize:`${props.titlesize}px`,color:props.trapColor}}>{titulo}</label>
                <label className='c3 fw500 p7 ' style={{fontSize:`${props.subtitlesize}px`,color:props.subtextColor}}>{subtitulo}</label>
              </div>
              <div className='w30 row' >
              {props.datav.preco&&<>
                  <label className='fb'style={{fontSize:`${props.subtitlesize*0.95}px`,color:props.subtextColor}}>R$:</label>
                  <label className='fb' style={{fontSize:`${props.subtitlesize*1.95}px`,color:props.subtextColor}}>{props.datav.preco}</label> 
              </>}
              </div>
            </div>
            
          </div>
        
      </div>

        </div>
      </div>
      
      { modalData&&
            <div className='posiabste b2 h30 z16 w17 p10 cell-tamanho-metade55 bordaElements'>
              <div className='w100 row between'>
                 <label className=''>Titulo</label>
                <img src='https://cdn-icons-png.flaticon.com/128/70/70287.png' className='pp w10' onClick={() => setModaldata(!modalData)}/>
              </div>
              <input type='text' value={titulo} onChange={(e)=>setTitulo(e.target.value)}/>
              <label>Subtitulo</label>
              <input type='text' value={subtitulo} onChange={(e)=>setSubtitulo(e.target.value)}/>
            </div>
            }
      </div>
     
    </div>



    <div className="w100 he20 overflowY">
        <div className="w100 row between ma5">
          <div className="row w50">
          <img src='https://cdn-icons-png.flaticon.com/128/535/535285.png' className='w15 ml5' alt='plus / mais'/>
          <img src='https://cdn-icons-png.flaticon.com/128/5948/5948565.png' className='w15 ml5' alt='plus / mais'/>
          <img src='https://cdn-icons-png.flaticon.com/128/5728/5728145.png' className='w15 ml5' alt='plus / mais'/>
          </div>
          <div className="w50 row between">
           
          </div>
        </div>
        <label className="fs08em">{props.datal.legenda}</label>
        <div>
          <label className="w100 fs08em fw500">{props.datal.hashtag}</label>
        </div>
      </div>
    <div className='w100 row between'> 
        <div className='h5 w30 fs08em cont-circ8 pp b2 row center  m10' 
            onClick={() => setNumimg(numimg >= 9 ? 0 : numimg + 1)}>
              Imagem
              <img src='https://cdn-icons-png.flaticon.com/128/1829/1829415.png' alt='IcoEdit' className='w17 m10'/>
            </div>
        <div 
            className='w30 h5 fs08em cont-circ8 pp b2 row center  m10'
            onClick={() => setModaldata(!modalData)}>
            {modalData ? "Fech." : "Texto"}
            <img src={IcoEdit} alt='IcoEdit' className='w25'/>
        </div>
        <div 
          className="w30 h5 fs08em cont-circ8 pp b2 row center  m10" 
          onClick={() => handleDownloadImage('resultImg22')}>
            Baixar
          <img src='https://cdn-icons-png.flaticon.com/128/5191/5191992.png' alt='IcoEdit' className='w17 m10'/>
        </div>
      </div> 
    </div>
  )
}